import type { SemanticColorKey } from "../../theme/tokens/colors"

/**
 * La face de la croix d'`<Overlay withCloseButton>` : une pastille de nuit, glyphe blanc, dans tous
 * les thèmes. La croix tombe tantôt sur le voile, tantôt sur le panneau d'une visionneuse (le
 * navigateur de `<LinkDisplay>` est blanc en clair, le PDF est noir) : un glyphe seul ne peut pas être
 * lisible sur les deux. Elle porte donc son propre fond, qui ne s'inverse pas sur la nuit.
 */
export const CLOSE_BUTTON_FILL: SemanticColorKey = "surface-night"
export const CLOSE_BUTTON_INK: SemanticColorKey = "text-on-night"
